<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ data.title }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="content-content" *ngIf="data.description || data.templateDescription">
            <div class="content-description" [innerHTML]="data.description"></div>
            <div class="content-description" [innerHTML]="data.templateDescription"></div>
        </div>
        <div class="content-action">
            <div class="default-form-field">
                <mat-label>{{ 'CONFIGURATION.OFFER_TITLE_PLACEHOLDER' | translate }}</mat-label>
                <mat-form-field fxFlex class="bordered-field" appearance="outline">
                    <input matInput maxlength="100" [(ngModel)]="offerTitle" required />
                    <mat-hint align="end">{{ offerTitle.length }} / 100</mat-hint>
                    <mat-error> {{ 'CONFIGURATION.VALIDATION.PLEASE_PROVIDE_TITLE_MESSAGE' | translate }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close color="primary">{{ data.cancel }}</button>
        <button mat-flat-button color="primary" [mat-dialog-close]="offerTitle" [disabled]="!offerTitle">
            {{ data.confirm }}
        </button>
    </mat-dialog-actions>
</div>
